var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgValues(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 153.88 122.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9ca5ad;}.cls-2{fill:#505050;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vectors"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "47.63 17.34 107.3 17.34 132.56 8.62 107.97 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "107.97 0 44.93 0 20.34 8.62 47.63 17.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "47.63 17.34 20.34 8.63 0 28.42 40.39 46.12 47.63 17.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 28.42 77.43 122.45 40.39 46.12 0 28.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "40.39 46.12 114.55 46.12 107.3 17.34 47.64 17.34 40.39 46.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "40.39 46.12 77.43 122.45 114.55 46.12 40.39 46.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "77.43 122.45 153.88 28.94 114.55 46.12 77.43 122.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "107.3 17.34 114.55 46.12 153.88 28.94 132.56 8.62 107.3 17.34"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValues);
export default __webpack_public_path__ + "static/media/values.6c6e850d04e5ff4ade54a51e97194e17.svg";
export { ForwardRef as ReactComponent };